/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* AWS RDS database engine type.
*/
export enum AwsRdsEngine {
  Postgres = 'POSTGRES',
  Mysql = 'MYSQL',
  AuroraMysql = 'AURORA_MYSQL',
  AuroraPostgresql = 'AURORA_POSTGRESQL',
  SqlserverSe = 'SQLSERVER_SE',
  SqlserverEe = 'SQLSERVER_EE',
  SqlserverWeb = 'SQLSERVER_WEB',
  SqlserverEx = 'SQLSERVER_EX',
  OracleEe = 'ORACLE_EE',
  OracleSe2 = 'ORACLE_SE2',
  OracleSe1 = 'ORACLE_SE1',
  OracleSe = 'ORACLE_SE'
}
